module.exports = __webpack_public_path__ + "static/media/shredder.f129591b.svg";